import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap, map } from "rxjs/operators";

@Injectable()
export class ReferencesService {
  constructor(private http: HttpClientService) {}

  public create(reference): Observable<any> {
    const params = {
      reference: reference,
      phone: reference.phone.info,
      user_phone_id: reference.user_phone_id,
    };
    return this.http
      .post("/api/references/create_one_reference", params)
      .pipe(tap((_) => console.log("ReferencesService.create: Ok.")));
  }

  public update(reference, options?: { reference_phone_success_contact?: string }): Observable<any> {
    const params = {
      reference: reference,
      phone_info: reference?.phone?.info,
      phone_id: reference?.phone?.id,
      user_phone_id: reference?.user_phone_id,
      automatic_answer_status: reference?.automatic_answer_status,
      ...(options?.reference_phone_success_contact != null && {
        reference_phone_success_contact: options.reference_phone_success_contact,
      }),
    };
    return this.http
      .put("/api/references/" + reference.id + "/update_reference", params)
      .pipe(tap((_) => console.log("ReferencesService.update: Ok.")));
  }

  public delete(reference_id): Observable<any> {
    return this.http
      .delete("/api/references/" + reference_id + "/delete")
      .pipe(tap((_) => console.log("ReferencesService.delete: Ok.")));
  }

  public obtainQuestions(reference_id, questions_type = undefined): Observable<any> {
    const params = {
      questions_type: questions_type,
    };

    return this.http
      .get("/api/references/" + reference_id + "/questions", { params })
      .pipe(tap((_) => console.log("ReferencesService.obtainQuestions: Ok.")));
  }

  public saveReferenceCallQuestion(reference, update_automatic_questions = false): Observable<any> {
    const params = {
      reference: reference,
      body: reference?.body,
      update_automatic_questions: update_automatic_questions,
    };

    return this.http
      .post("/api/references/" + reference.id + "/questions", params)
      .pipe(tap((_) => console.log("ReferencesService.saveReferenceCallQuestion: Ok.")));
  }

  public getRepeatedReference(reference_id): Observable<any> {
    return this.http
      .get("/api/references/" + reference_id + "/repetead_references")
      .pipe(tap((_) => console.log("ReferencesService.getRepeatedReference: Ok.")));
  }

  public get_titular_applications(reference_id): Observable<any> {
    return this.http
      .get("/api/references/" + reference_id + "/applications_titular")
      .pipe(tap((_) => console.log("ReferencesService.get_titular_applications: Ok.")));
  }
}
